<template>
    <div class="app-container mt-5">
        <div class="d-flex justify-content-between">
            <div class="page-title mb-3">
                <router-link to="/configuration">
        <span class="breadcrumb-link">
          <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
        </span>
                </router-link>
                <v-icon>keyboard_arrow_right</v-icon>
                <span class="breadcrumb-item">
        <v-icon class="breadcrumb-item-icon">search</v-icon> Ma veille
      </span>
            </div>

            <div class="text-right">
                <v-btn
                  class="default-button"
                  @click="saveVtcConfiguration">
                    <v-icon>save</v-icon>
                    Enregistrer tout
                </v-btn>
            </div>
        </div>

        <v-card class="p-2 mb-5">
            <v-card-text>
                <div class="mb-8">
                    <h3>Fonctionnement</h3>

                    <div>
                        <div class="d-flex justify-content-between border-bottom">
                            <div v-if="vtcConfig.active">
                                <h5 class="pt-4">
                                    Veille | Active
                                </h5>
                                <span class="mb-3">
                                Le système de veille des prestataires s'exécute chaque semaine
                            </span>
                            </div>
                            <div v-else>
                                <h5 class="pt-4">
                                    Veille | Inactive
                                </h5>
                                <span class="mb-3">
                                Le système de veille des prestataires n'est pas exécuté
                            </span>
                            </div>

                            <v-switch
                              v-model="vtcConfig.active"
                              hide-details
                              class="pt-0 mt-0 ml-8 pb-4"
                            ></v-switch>
                        </div>

                        <div class="d-flex justify-content-between border-bottom"
                             v-if="account.tis_type.code === 'APIDAE'">
                            <div v-if="vtcConfig.auto_write">
                                <h5 class="pt-4">
                                    Ecriture automatique | Active
                                </h5>
                                <span class="mb-3">
                                Les modifications d'informations validées sont automatiquement envoyées sur Apidae sous
                                    forme de brouillon à valider
                            </span>
                            </div>
                            <div v-else>
                                <h5 class="pt-4">
                                    Ecriture automatique | Inactive
                                </h5>
                                <span class="mb-3">
                                Les modifications d'informations validées ne sont pas automatiquement envoyées sur
                                    Apidae
                            </span>
                            </div>

                            <v-switch
                              v-model="vtcConfig.auto_write"
                              hide-details
                              class="pt-0 mt-0 ml-8 pb-4"
                            ></v-switch>
                        </div>
                    </div>
                </div>

                <div>
                    <h3 class="mb-5">Notifications</h3>

                    <div class="mb-4">
                        <h4>Pour les Prestataires</h4>

                        <div class="d-flex justify-content-between border-top">
                            <div>
                                <h5 class="pt-4">
                                    Envoi d'un e-mail de validation au prestataire
                                </h5>
                                <span>
                                Le prestataire sera sollicité pour valider chaque changements d'information détecté sur
                                sa page
                            </span>
                            </div>

                            <v-switch
                              v-model="vtcConfig.pro_validation_asked"
                              hide-details
                              class="pt-0 mt-0 ml-8 pb-4"
                            ></v-switch>
                        </div>

                        <div class="ml-3" v-if="vtcConfig.pro_validation_asked">
                            <div class="mt-5">
                                <h5 class="mb-2">Boite d'envoi des e-mails adressés aux prestataires</h5>
                                <span>
                            Cette boîte d'envoi sera utilisée pour l'envoi d'une notification au prestataire quand une
                            nouvelle information sera détectée
                        </span>

                                <v-select :items="senders" outlined style="padding-top: 0 !important;"
                                          class="no-details mt-2 mb-5"
                                          :class="{'input-error':
                                          !isValid && vtcConfig.pro_validation_asked &&
                                          (!vtcConfig.sender || !vtcConfig.sender.id)}"
                                          item-text="emailable.email"
                                          return-object
                                          @change="selectSender"
                                          :value="vtcConfig.sender"
                                >
                                    <v-tooltip slot="append-outer" bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on">help</v-icon>
                                        </template>
                                        <span>Adresse E-mail et Nom d'expéditeur que verront vos prestataires.</span>
                                    </v-tooltip>

                                    <template slot="selection" slot-scope="data">
                <span v-if="data.item.name !== null" class="pr-2">
                    {{ data.item.name }}
                </span>
                                        <span>({{ data.item.emailable.email }})</span>
                                    </template>
                                    <template slot="item" slot-scope="data">
                <span v-if="data.item.name !== null" class="pr-2">
                    {{ data.item.name }}
                </span>
                                        <span>({{ data.item.emailable.email }})</span>
                                    </template>
                                </v-select>
                            </div>

                            <div>
                                <h5 class="mb-2">Message en cas de validation</h5>
                                <span class="mb-8">
                                Ce message sera affiché lorsque le prestataire valide la modification d'information
                            </span>

                                <ckeditor :editor="editor" v-model="vtcConfig.accept_message"></ckeditor>
                            </div>

                            <div class="mt-5">
                                <h5 class="mb-2">Message en cas de refus</h5>
                                <span class="mb-3">
                                Ce message sera affiché lorsque le prestataire refuse la modification d'information
                            </span>

                                <ckeditor :editor="editor" v-model="vtcConfig.denial_message"></ckeditor>
                            </div>

                            <div class="mt-5">
                                <h5>
                                    Délai d'attente sans validation du prestataire
                                </h5>
                                <span>
                                Délai avant de recevoir la notification de changement d'information en cas d'absence de
                                réponse du prestataire
                            </span>
                                <div class="d-flex w-25">
                                    <v-text-field
                                      outlined
                                      v-model="vtcConfig.auto_validation_delay"
                                      hide-details
                                      type="number"
                                      min="0"
                                      max="100"
                                      :step="1"
                                      class="mr-2"
                                      suffix="Jour(s)"
                                      :disabled="!vtcConfig.pro_validation_asked"
                                    ></v-text-field>

                                    <v-tooltip slot="append-outer" bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on">help</v-icon>
                                        </template>
                                        <span>
                                Si le champ est vide ou égal à 0, la validation automatique ne s'applique pas.
                            </span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-8 mb-4">
                        <h4>Pour l'Office de Tourisme</h4>

                        <div class="d-flex justify-content-between border-top">
                            <div>
                                <h5 class="pt-4">
                                    Nouvelles informations
                                </h5>
                                <span>
                                Vous recevrez une notification à chaque nouvelle information disponible dans votre
                                espace de veille
                            </span>
                            </div>

                            <v-switch
                              v-model="vtcConfig.notif_ot"
                              hide-details
                              class="pt-0 mt-0 ml-8 pb-4"
                            ></v-switch>
                        </div>

                        <div class="ml-3" v-if="vtcConfig.notif_ot">
                            <div class="mt-5">
                                <h5 class="mb-2">Boite de réception des notifications</h5>
                                <span>
                            L'email qui recevra les notifications concernant la veille
                        </span>

                                <v-select :items="account.users" outlined style="padding-top: 0 !important;"
                                          item-text="email"
                                          class="no-details mt-2 mb-5"
                                          :class="{'input-error': !isValid && vtcConfig.notif_ot &&
                                          (!vtcConfig.user || !vtcConfig.user.id)}"
                                          return-object
                                          @change="selectUser"
                                          :value="vtcConfig.user"
                                ></v-select>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>

        <div class="text-right mb-3">
            <v-btn
              class="default-button"
              @click="saveVtcConfiguration">
                <v-icon>save</v-icon>
                Enregistrer tout
            </v-btn>
        </div>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapState } from "vuex"
import Confirm from "@/components/tools/Confirm.vue"
import ClassicEditor from "../../../plugins/ckeditor"

export default {
    name: "VtConfig",
    components: { Confirm },
    data() {
        return {
            vtcConfig: {
                id: null,
                sender: {},
                denial_message: "",
                accept_message: "",
                pro_validation_asked: true,
                auto_validation_delay: null,
                notif_ot: false,
                user: {},
                active: false,
                auto_write: false,
            },
            editor: ClassicEditor,
            isValid: true,
        }
    },
    methods: {
        selectSender(sender) {
            this.vtcConfig.sender = sender
        },
        selectUser(user) {
            this.vtcConfig.user = user
        },
        getVtcConfiguration() {
            this.$global.loading = true

            this.$http.get("/veille-tourisme/vtc-configuration/" + this.account.id).then((res) => {
                if (res.body.data.vtcConfiguration !== null) {
                    this.vtcConfig = res.body.data.vtcConfiguration
                }

                this.$store.dispatch("account/loadSenders")
                this.$global.loading = false
            })
        },
        saveVtcConfiguration() {
            if ((this.vtcConfig.pro_validation_asked && !this.vtcConfig.sender?.id) ||
              (this.vtcConfig.notif_ot && !this.vtcConfig.user?.id)) {
                this.isValid = false
            } else {
                let payload = {
                    accountId: this.account.id,
                    vtcConfigurationId: this.vtcConfig.id,
                    senderId: this.vtcConfig.sender?.id,
                    acceptMessage: this.vtcConfig.accept_message,
                    denialMessage: this.vtcConfig.denial_message,
                    proValidationAsked: this.vtcConfig.pro_validation_asked,
                    autoValidationDelay: this.vtcConfig.auto_validation_delay,
                    notifOt: this.vtcConfig.notif_ot,
                    userId: this.vtcConfig.user?.id,
                    active: this.vtcConfig.active,
                    autoWrite: this.vtcConfig.auto_write,
                }

                if (confirm && this.vtcConfig.id === null) {
                    this.$global.loading = true

                    this.$http.put("/veille-tourisme/vtc-configuration/create", payload).then((res) => {
                        this.$global.loading = false
                        this.vtcConfig = res.body.data.vtcConfiguration
                    })
                } else if (confirm) {
                    this.$global.loading = true

                    this.$http.put("/veille-tourisme/vtc-configuration/update", payload).then((res) => {
                        this.$global.loading = false
                        this.vtcConfig = res.body.data.vtcConfiguration
                    })
                }
            }
        },
    },
    computed: {
        ...mapState("account", ["account", "user", "senders"]),
    },
    created() {
        this.$store.dispatch("account/loadSenders")
        this.getVtcConfiguration()
    },
}
</script>